import React from 'react';

import {
	withAnalyticsEvents,
	createAndFireEvent,
	type WithAnalyticsEventsProps,
	type UIAnalyticsEvent,
} from '@atlaskit/analytics-next';

import Link from '@atlaskit/link';

const createAndFireEventOnAtlaskit = createAndFireEvent('atlaskit');

interface ButtonProps extends WithAnalyticsEventsProps {
	onClick?: (e: React.MouseEvent, analyticsEvent: UIAnalyticsEvent) => void;
	href: string;
	target?: string;
	rel?: string;
	testId?: string;
	children: React.ReactNode;
}

const ButtonBase = (props: ButtonProps) => <Link {...props} />;
export default withAnalyticsEvents({
	onClick: createAndFireEventOnAtlaskit({
		action: 'clicked',
		actionSubject: 'link',
	}),
})(ButtonBase);
